import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

export function UserMenu() {
  const { t } = useTranslation();
  const { adminId, user, logout } = useAuth();

  return (
    <>
      <a className="nav-link" data-bs-toggle="dropdown" href="#">
        <i className="bi bi-person-circle"></i>
        <span className="d-none d-md-inline">{user?.username || t('user_menu.admin', 'Admin {{id}}', { id: adminId })}</span>
      </a>
      <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end">
        <a href="#" className="dropdown-item">
          <i className="bi bi-gear me-2"></i> {t('navigation.settings', 'Settings')}
        </a>
        <div className="dropdown-divider"></div>
        <a href="#" className="dropdown-item" onClick={logout}>
          <i className="bi bi-box-arrow-right me-2"></i> {t('user_menu.logout', 'Logout')}
        </a>
      </div>
    </>
  );
}
